import { employeeSalaries } from '../employeeSalary'
import { describeTable } from './describeTable'

describeTable(employeeSalaries, {
  description: `Salary history (palkka) of an employee, time-sliced: one row per agreed pay level with valid_from / valid_to, so pick the row where the date of interest falls inside [valid_from, coalesce(valid_to, 'infinity')]. valid_to IS NULL = current salary. Rows join employees.id (not users.id).
Either monthly_salary or hourly_salary is filled, according to salary_type; the other is NULL. Amounts are gross pay in euros before employer side costs. The profitability model multiplies by the employer cost multiplier EMPLOYER_COST_MULTIPLIER = 1.5 (@markku/utils) and, for monthly salaries, spreads the month over working days × 7.5 h to get a per-hour cost; hourly salaries are multiplied by hours worked (hour_sheets).
Sensitive personal data — readable for management analysis, but never list individual salaries beside names unless the question is explicitly about pay.`,
  columns: {
    salaryType:
      'monthly = fixed monthly pay (kuukausipalkka); hourly = paid per logged hour (tuntipalkka).',
    monthlySalary:
      'Gross monthly pay in euros, VAT-free. Only when salary_type = monthly.',
    hourlySalary: 'Gross hourly pay in euros. Only when salary_type = hourly.',
    validFrom: 'First day this pay level applies.',
    validTo: 'Last day this pay level applies; NULL = still in force.',
    notes: 'Free text about the change (raise reason etc).',
  },
})
